module.exports = __webpack_public_path__ + "static/media/Carbink_gaussian2.1d008745.png";